import { render, staticRenderFns } from "./BringToTeam.vue?vue&type=template&id=275042d2&scoped=true&"
import script from "./BringToTeam.vue?vue&type=script&lang=js&"
export * from "./BringToTeam.vue?vue&type=script&lang=js&"
import style0 from "./BringToTeam.vue?vue&type=style&index=0&id=275042d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275042d2",
  null
  
)

export default component.exports